import __request__ from "routing/request";
export function get(requestOptions) {
  return __request__("GET", "/mcp", null, {}, {
    "Accept": ["text/event-stream"]
  }, requestOptions);
}
export function post(jsonrpc_message, requestOptions) {
  return __request__("POST", "/mcp", jsonrpc_message, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
